import React from 'react';

export const APP_CREAM = '#E8E2DA';

const NotificationOverlayFrame = ({
  accentColor,
  children,
  messageColor = accentColor,
  showLogo = false,
  role = 'status',
  ariaLive = 'polite',
  ariaAtomic
}) => (
  <>
    <style>{`
      @media (max-width: 1023px) {
        .mytool-notification-overlay-frame {
          top: max(30vh, calc(104px + env(safe-area-inset-top))) !important;
          transform: translateX(-50%) !important;
        }
      }
    `}</style>
    <div
      className="mytool-notification-overlay-frame"
      style={{
        position: 'fixed',
        top: '30vh',
        left: 'calc((100vw + var(--mytool-main-content-left, 0px)) / 2)',
        transform: 'translate(-50%, -50%)',
        zIndex: 100000,
        width: 'min(640px, calc(100vw - var(--mytool-main-content-left, 0px) - 32px))',
        boxSizing: 'border-box',
        border: `6px solid ${accentColor}`,
        background: 'linear-gradient(180deg, #0b0f1a 0%, #000 100%)',
        color: messageColor,
        padding: 'clamp(18px, 3vw, 26px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: showLogo ? 'flex-start' : 'center',
        gap: showLogo ? '16px' : 0,
        textAlign: showLogo ? 'left' : 'center',
        pointerEvents: 'none'
      }}
      role={role}
      aria-live={ariaLive}
      aria-atomic={ariaAtomic}
    >
      {showLogo && (
        <div style={{
          width: 60,
          height: 60,
          flex: '0 0 60px',
          border: `3px solid ${accentColor}`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: '#000'
        }}>
          <img
            src="/mtnappicon.png"
            alt="MyTool NOW"
            style={{ width: 50, height: 50, objectFit: 'contain' }}
          />
        </div>
      )}

      <div style={{ flex: 1, minWidth: 0 }}>
        {children}
      </div>
    </div>
  </>
);

export default NotificationOverlayFrame;
